import { AppSubdomains } from 'src/types/common';

interface LaunchNotificationConfig {
  storeClosed: {
    title: string;
    description: string;
    nextOpenDescription?: string;
  };
  outOfCoverage: {
    title: string;
    description: string;
  };
}

const DEFAULT_LAUNCH_NOTIFICATIONS: LaunchNotificationConfig = {
  storeClosed: {
    title: '¡Oops, tienda cerrada!',
    description:
      'La tienda estará disponible próximamente y podrás realizar tu pedido sin ningún problema.',
    nextOpenDescription:
      'La tienda estará disponible a partir de las {time} hrs y podrás realizar tu pedido sin ningún problema.',
  },
  outOfCoverage: {
    title: '¡Oops, fuera del área de cobertura!',
    description:
      'Lamentamos el inconveniente, por ahora no tenemos cobertura en tu zona.',
  },
};

export default function getLaunchNotifications(
  subdomain: AppSubdomains
): LaunchNotificationConfig | null {
  switch (subdomain) {
    case AppSubdomains.Pari:
      return DEFAULT_LAUNCH_NOTIFICATIONS;
    case AppSubdomains.Homebar:
      return {
        storeClosed: {
          title: 'Entrega inmediata no disponible',
          description:
            'Tu pedido se enviará lo antes posible. Recibirás el número de seguimiento de la transportadora en tu correo.',
        },
        outOfCoverage: {
          title: 'Entrega inmediata no disponible',
          description:
            'Tu pedido se enviará lo antes posible. Recibirás el número de seguimiento de la transportadora en tu correo.',
        },
      };
    case AppSubdomains.Terea:
      return null;
    default:
      return DEFAULT_LAUNCH_NOTIFICATIONS;
  }
}
